import styled, { css } from 'styled-components';
import { colors } from '../../../assets/variables';

const Wrap = styled.div`
  position: relative;
  ${(props) => {
    if (props.appWidth > 800) {
      return desktopStyles;
    }
  }}
`;

const BoxWrap = styled.div`
  position: relative;
  background-color: white;
  border: 4px solid #d7f1ff;
  border-radius: 10px;
  padding: 24px 32px;
  margin-bottom: 20px;
`;
const ErrorWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ErrorList = styled.ul`
  padding-inline-start: 0px;
  color: ${colors.error};
  font-weight: 600;
`;
const List = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
  &:before {
    content: none !important; /* This is used by South East Water */
  }
`;

const ListQuantity = styled.div`
  color: ${colors.primary};
  font-weight: bolder;
  margin-right: 8px;
  font-size: 20px;
  ${(props) => {
    if (props.disabled) {
      return css`
        text-decoration: line-through;
        color: ${colors.disabled};
      `;
    }
  }};
`;
const ListText = styled.div`
  color: #174489;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  ${(props) => {
    if (props.disabled) {
      return css`
        text-decoration: line-through;
        color: ${colors.disabled};
      `;
    }
  }};
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 16px;
`;
const ProductList = styled.ul`
  list-style: none;
  margin: 0 0 20px 0;
  padding: 0;
`;
const ErrorMessage = styled.div`
  font-size: 0.8em;
  color: ${colors.error};
  margin-top: 2px;
  margin-bottom: 16px;
  line-height: 1.2;
`;

const AddressWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const FullAddress = styled.div`
  font-weight: bolder;
  color: ${colors.primary};
`;

const Postcode = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.primary};
  margin-top: 0;
  span {
    font-size: 48px;
    font-weight: 700;
    color: #174489;
    line-height: 62px;
    font-family: 'DM Sans', sans-serif;
  }
`;

const Disclaimer = styled.p`
  font-size: 14px;
  line-height: 1.5;
  padding-right: 10px;
  font-family: 'DM Sans', sans-serif;
`;

const desktopStyles = css`
  ${Postcode} {
    padding-top: 16px;
  }
  ${AddressWrap} {
    flex-direction: row;
    justify-content: space-between;
  }

  ${ErrorWrap} {
    flex-direction: row;
  }
`;
const CheckButton = styled.div`
  background-color: #d7f1ff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;
const ListWrap = styled.div`
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 16px;
`;
export default {
  Wrap,
  BoxWrap,
  List,
  ListQuantity,
  ProductList,
  ListText,
  ErrorMessage,
  Disclaimer,
  AddressWrap,
  Postcode,
  FullAddress,
  ErrorWrap,
  TextGroup,
  CheckButton,
  ErrorList,
  ListWrap,
};
